<template>
  <div class="inputBox" :style="{ width: width,borderRadius:borderRadius }">
    <svg
      @click="doSearch"
      t="1682061410305"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="2621"
      width="32"
      height="32"
    >
      <path
        d="M192 480a256 256 0 1 1 512 0 256 256 0 0 1-512 0m631.776 362.496l-143.2-143.168A318.464 318.464 0 0 0 768 480c0-176.736-143.264-320-320-320S128 303.264 128 480s143.264 320 320 320a318.016 318.016 0 0 0 184.16-58.592l146.336 146.368c12.512 12.48 32.768 12.48 45.28 0 12.48-12.512 12.48-32.768 0-45.28"
        fill="#999999"
        p-id="2622"
      ></path>
    </svg>
    <input @blur="inputBlur" v-model="userName" :placeholder="placeholder" />
  </div>
</template>

<script>
export default {
  name: "inputBox",
  props: {
    width: {
      type: String,
      default: "",
    },
    borderRadius: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "请输入用户姓名、账号",
    },
  },
  data() {
    return {
      userName: "",
    };
  },
  methods: {
    inputBlur() {
      let userName = this.userName;
      this.$emit("inputBlur", { userName });
    },
    doSearch() {
      this.$emit("doSearch");
    },
  },
};
</script>

<style lang="less" scoped>
.inputBox {
  display: flex;
  align-items: center;

  width: 494px;
  height: 72px;
  border-radius: 22px;
  border: 1px solid #e6e6e6;
  svg {
    width: 34px;
    height: 34px;
    margin-left: 16px;
    margin-right: 8px;
  }
  input {
    margin-right: 16px;
    flex-grow: 1;
    border: none;
    font-size: 28px;
  }
}
</style>
